const approveStatus = [
    {
        label: '未审批',
        value: 0,
    },
    {
        label: '审批通过',
        value: 1,
    },
    {
        label: '审批驳回',
        value: 2,
    },
    {
        label: '流程撤回',
        value: 3,
    },
]

const getApproveStatusName = function (key) {
    const exist = approveStatus.find((t) => t.value === key)
    return exist ? exist.label : ''
}

module.exports = {
    approveStatus,
    getApproveStatusName,
}
